import { TaskRow } from "../types";

export const tasks: TaskRow[] = [
    {
      name: "Задача 1",
      activity_last_date: "01-12-2024 12:30",
      deadline: "05-12-2024 18:00",
      user_evecuter: "Иван Иванов",
      user_master: "Петр Петров"
    },
    {
      name: "Задача 2",
      activity_last_date: "02-12-2024 14:45",
      deadline: "07-12-2024 15:00",
      user_evecuter: "Мария Смирнова",
      user_master: "Алексей Кузнецов"
    },
    {
      name: "Задача 3",
      activity_last_date: "03-12-2024 10:00",
      deadline: "06-12-2024 09:00",
      user_evecuter: "Ольга Васильева",
      user_master: "Игорь Логинов"
    },
    {
      name: "Задача 4",
      activity_last_date: "04-12-2024 16:00",
      user_evecuter: "Иван Иванов",
      user_master: "Андрей Сергееев"
    },
    {
      name: "Задача 5",
      activity_last_date: "05-12-2024 08:30",
      user_evecuter: "Светлана Романова",
      user_master: "Николай Павлов"
    },
    {
      name: "Задача 6",
      activity_last_date: "06-12-2024 11:00",
      deadline: "09-12-2024 10:00",
      user_evecuter: "Дмитрий Смирнов",
      user_master: "Елена Воробьева"
    },
    {
      name: "Задача 7",
      activity_last_date: "07-12-2024 09:30",
      user_evecuter: "Марина Власова",
      user_master: "Владимир Лысенко"
    },
    {
      name: "Задача 8",
      activity_last_date: "08-12-2024 17:00",
      deadline: "12-12-2024 14:00",
      user_evecuter: "Константин Петров",
      user_master: "Юлия Курочкина"
    },
    {
      name: "Задача 9",
      activity_last_date: "09-12-2024 13:00",
      user_evecuter: "Лариса Мартынова",
      user_master: "Сергей Попов"
    },
    {
      name: "Задача 10",
      activity_last_date: "10-12-2024 09:00",
      deadline: "15-12-2024 16:00",
      user_evecuter: "Александр Иванов",
      user_master: "Елена Кузьмина"
    }
  ];

export const taskStatusNames = [
  {
    id: 1,
    name: "Запланирована"
  },
  {
    id: 2,
    name: "Завершена"
  },
  {
    id: 3,
    name: "Выполнена"
  }
]

export const taskUserStatusNames = [
  /* {
    id: 1,
    name: "Постановщик"
  }, */
  {
    id: 2,
    name: "Исполнитель"
  },
  {
    id: 3,
    name: "Соисполнитель"
  },
  {
    id: 4,
    name: "Наблюдатель"
  }
]